import { NavLink } from "react-router-dom";
import "../styles/global.css";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { HiOutlineHome } from "react-icons/hi";

function SideBar() {
  return (
    <div className="sidebar">
      <div className="name-app">
        <div className="icon-app">
          <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.2771 5.74099C14.4226 6.30304 14.5 6.89248 14.5 7.5C14.5 11.366 11.366 14.5 7.5 14.5C3.63401 14.5 0.5 11.366 0.5 7.5C0.5 3.63401 3.63401 0.5 7.5 0.5C9.99346 0.5 11.5 1 13 3" stroke="white" stroke-linecap="round"/>
<path d="M4.5 5L6.5 9.5L16.5 2.5" stroke="white" stroke-linecap="round"/>
</svg>
        </div>
        
        <h2>Menu</h2>
      </div>
      <ul>
        <li className="nav-item">
          <HiOutlineHome />
          <NavLink
            className={({ isActive }) => (isActive ? "active" : "")}
            to="/"
          >
            Home
          </NavLink>
        </li>
        <li className="nav-item">
          <HiOutlineCheckCircle />
          <NavLink
            className={({ isActive }) => (isActive ? "active" : "")}
            to="/add-task"
          >
            Adicionar Tarefa
          </NavLink>
        </li>
      </ul>
    </div>
  );
}

export default SideBar;
